
var id = "message";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 14\" id=\"message\">\n<style type=\"text/css\">\n\t#message .st0{}\n</style>\n<title>短信模板管理</title>\n<g id=\"message_短信管理\">\n\t<g id=\"message_left-menu-sidebar\" transform=\"translate(-32.000000, -481.000000)\">\n\t\t<g transform=\"translate(-0.000000, 64.000000)\">\n\t\t\t<g id=\"message_Group-4-Copy\" transform=\"translate(0.000000, 400.000000)\">\n\t\t\t\t<g id=\"message_Group\" transform=\"translate(-0.000000, 0.000000)\">\n\t\t\t\t\t<g id=\"message_短信模板管理\" transform=\"translate(32.000000, 17.000000)\">\n\t\t\t\t\t\t<path id=\"message_Shape\" class=\"st0\" d=\"M13.3,1.6H1c-0.6,0-1,0.5-1,1.1v10.3C0,13.5,0.5,14,1,14h12.3c0.6,0,1-0.5,1-1.1V2.6\n\t\t\t\t\t\t\tC14.3,2.1,13.9,1.6,13.3,1.6z M12.3,2.7l-4.9,4C7.2,6.8,7.1,6.8,7,6.7l-4.9-4H12.3z M1.1,12.8V3.4l5.2,4.2\n\t\t\t\t\t\t\tC6.6,7.9,6.9,8,7.2,8S7.8,7.9,8,7.7l5.2-4.2v9.4H1.1z\" />\n\t\t\t\t\t\t<path id=\"message_Path\" class=\"st0\" d=\"M15,0H6C5.7,0,5.5,0.3,5.5,0.6S5.7,1.2,6,1.2h8.8V10c0,0.3,0.2,0.6,0.6,0.6\n\t\t\t\t\t\t\tc0.3,0,0.6-0.3,0.6-0.6V1.1C16,0.5,15.5,0,15,0z\" />\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
